import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import useAuth from "src/hooks/useAuth";
import { useProject } from "../ProjectProvider";
import Outbound from "../outbound/Outbound";
import Internal from "../internal/Internal";

export default function OrdersTab({ onClose, activeView, onChange }) {
  const { user } = useAuth();
  const { settings } = user.company;
  const { project } = useProject();

  const outboundEnabled = settings?.inventory_tracking && project?.settings?.display_in_store;
  const companyInternalEnabled = settings?.internal_work_orders;
  const internalEnabled = companyInternalEnabled && user?.canAccessShoppingInternalWorkOrders;

  const initialView = outboundEnabled ? "outbound" : internalEnabled ? "internal" : null;

  const currentView = ["outbound", "internal"].includes(activeView) ? activeView : initialView;

  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      if (onChange) {
        onChange(newView);
      }
    }
  };

  const showToggles = [outboundEnabled, internalEnabled].filter(Boolean).length > 1;

  if (!currentView) return null;

  const tabs = showToggles ? (
    <Box display="flex" mb={2} borderBottom={1} borderColor="divider">
      <Tabs
        value={currentView}
        onChange={handleViewChange}
        aria-label="orders view"
        sx={{
          "& .MuiTab-root": {
            textTransform: "none",
            minWidth: "fit-content",
            px: 2,
          },
        }}
      >
        {outboundEnabled && <Tab value="outbound" label="Outbound Orders" />}
        {internalEnabled && <Tab value="internal" label="Internal Work Orders" />}
      </Tabs>
    </Box>
  ) : null;

  return (
    <Box>
      {currentView === "outbound" && outboundEnabled && <Outbound title={tabs} onClose={onClose} />}
      {currentView === "internal" && internalEnabled && <Internal title={tabs} onClose={onClose} />}
    </Box>
  );
}
